(() => {
  const root = window.Shopify?.routes?.root || '/';
  let activeRequest = null;

  const getConfig = (productId) => {
    const config = document.querySelector('[data-zorinen-gift-config]');
    const addonConfig = document.querySelector('[data-zorinen-addon-config]');
    if (config && productId && String(config.dataset.productId) !== String(productId)) return null;
    if (!config && !addonConfig) return null;

    const variantIds = (config?.dataset.giftVariantIds || '')
      .split(',')
      .map((id) => Number(id.trim()))
      .map((id) => (Number.isInteger(id) && id > 0 ? id : null));
    const productIds = (config?.dataset.giftProductIds || '')
      .split(',')
      .map((id) => Number(id.trim()))
      .map((id) => (Number.isInteger(id) && id > 0 ? id : null));
    const addonItems = [...(addonConfig?.querySelectorAll('[data-zorinen-addon-checkbox]:checked') || [])]
      .map((input) => ({
        variantId: Number(input.dataset.variantId),
        productId: Number(input.closest('[data-zorinen-addon-config]')?.dataset.addonProductIds?.split(',')?.[
          [...(addonConfig?.querySelectorAll('[data-zorinen-addon-checkbox]') || [])].indexOf(input)
        ]),
      }))
      .filter(({ variantId }) => Number.isInteger(variantId) && variantId > 0);
    if (!variantIds.some(Boolean) && !addonItems.length) return null;

    return {
      config,
      variantIds,
      productIds,
      addonItems,
      perQuantity: config?.dataset.perQuantity === 'true',
      autoAddGifts: config?.dataset.autoAdd === 'true',
    };
  };

  const addGifts = async (detail = {}) => {
    const giftConfig = getConfig(detail.productId);
    if (!giftConfig) return;
    if (activeRequest) return activeRequest;

    activeRequest = (async () => {
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      if (!cartResponse.ok) throw new Error('Unable to read the cart.');

      const existingProductIds = new Set(cart.items.map((item) => Number(item.product_id)));
      const quantity = giftConfig.perQuantity ? Math.max(1, Number(detail.quantity) || 1) : 1;
    const giftItems = giftConfig.autoAddGifts ? giftConfig.variantIds
      .slice(0, 1)
      .map((variantId, index) => ({ variantId, productId: giftConfig.productIds[index] }))
      .filter(({ variantId, productId }) => variantId && (!productId || !existingProductIds.has(productId)))
      .map(({ variantId }) => ({
        id: variantId,
        quantity,
        properties: { _zorinen_gift: 'bundle' },
      })) : [];
      const addonItems = giftConfig.addonItems
        .filter(({ variantId, productId }) => variantId && (!productId || !existingProductIds.has(productId)))
        .map(({ variantId }) => ({ id: variantId, quantity: 1, properties: { _zorinen_addon: 'selected' } }));
      const items = [...giftItems, ...addonItems];

      if (!items.length) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const payload = { items };
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // Allow the promotional request to finish if the product page navigates
        // to the cart immediately after the main item is added.
        keepalive: true,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add promotional gifts.');

      if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      }
      document.dispatchEvent(new CustomEvent('zorinen:gifts-added', { detail: { items, cartData: data } }));
      return data;
    })().finally(() => {
      activeRequest = null;
    });

    return activeRequest;
  };

  window.ZorinenGiftAutoAdd = addGifts;
  document.addEventListener('zorinen:product-added', (event) => {
    addGifts(event.detail).catch((error) => console.error('Unable to add promotional gifts:', error));
  });
})();
